import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UtilService } from 'src/app/common-services/util.service';
import { SupplierV2 } from '../models/item-response-model-v2';

@Component({
    selector: 'view-supplier',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './view-supplier.component.html'
})
export class ViewSupplierComponent {  
  @Input() supplierModel: SupplierV2;
  
  constructor(
    // private utilService: UtilService, 
    public activeModal: NgbActiveModal) {
    
  }

  public close() {
      this.activeModal.close('close');
  }

  private formatDateTime(datetime: string): string {
    if(datetime != undefined) {
      return datetime.replace('T', ' ');
    } else {
      return '';
    }
  }
}
